<template>

    <div class="page-wrapper">

       <!-- Menu Superior de Navegación -->
       <navbar-new></navbar-new>

       <gallery-start></gallery-start>
      
        <gallery-page></gallery-page>
        
       <!-- Pie de Página -->
       <footer-new></footer-new>
        

    </div>
</template>
  
<script>
  import navbarNew from '../components/navbar.vue'

  import galleryStart from '../components/gallery/galleryStart.vue'

  import galleryPage from '../components/gallery/galleryPage.vue'

  import footerNew from '../components/footer.vue'

  export default {
    components: {
    navbarNew,
    galleryStart,
    galleryPage,
    footerNew
  }
  }
  
</script>
  